import React, { useState, useEffect } from "react";
import "./index.scss";
const Alerts = (props: any) => {

  const [isShow, setIsShow] = useState(true);

  useEffect(() => {
    if (props.time) {
      const timeDuration = setTimeout(() => {
        setIsShow(false);
        if (props.onClose)
          props.onClose();
      }, props.time);
      return () => clearTimeout(timeDuration);
    }
  }, [props.time, props.onClose]);

  const handleClose = () => {
    setIsShow(false);
    if (props.onClose)
      props.onClose();
  };

  return (
    <>
      {isShow ? (
        <div className={`alert ${props.alertType}`}>
        <span className="alertMessage">{props.messageAlert}</span>
                  {
                      !props?.restrictCancel
                          ?
                          <button
                              type="button"
                              className="close"
                              data-dismiss="alert"
                              aria-label="Close"
                              onClick={handleClose}
                          >
                              &times;
                          </button> : null
                  }
        
        </div>
      ) : (
        null
      )}
    </>
  );
};
export default Alerts;
